export const POINT_COLORS = {
  white: '#fff',
  lightBlue: '#83b4ff',
  regularBlue: '#0468ff',
  hoveredBlue: '#0661ec',
  activeBlue: '#0253c4',
  dark: '#152242',
  textBlue: '#0661ec',
  glowBlue: '4, 104, 255',
};

/**
 * @description
 * Параметры радиуса
 */
export const POINT_RADIUS = 6;
export const POINT_WITH_COUNT_RADIUS = 11;
export const EXTENDED_POINT_RADIUS = 5.5;
export const POINT_GLOW_RADIUS = POINT_RADIUS + 4;

/**
 * @description
 * Параметры ширины рамки
 */
export const POINT_BORDER_WIDTH = 1.5;
export const POINT_WITH_COUNT_BORDER_WIDTH = 2;
export const EXTENDED_POINT_BORDER_WIDTH = 1.5;

/**
 * @description
 * Параметры значений каунтера в пине
 */
export const POINT_COUNT_MIN_VALUE = 2;
export const POINT_COUNT_MAX_VALUE = 99;
